import { Repository } from './Repository';
import { Event } from '../models/Event';
import { FakeData } from './FakeData';

export class EventsRepository extends Repository {
  async getEventDetails(eventId: string, currentUserId: string): Promise<Event | null> {
    if(Repository.offlineMode) {
      return FakeData.getEvent();
    }

    const path = `v1/events/${eventId}`;
    const response = await Repository.client.get(path);
    return Event.fromJson(response.data.data.event, currentUserId);
  }

  async getEventsNearby(
    latitude: number, 
    longitude: number, 
    filter: string | null,
    currentUserId: string, 
    page: number, 
    itemsPerPage: number
  ): Promise<{data: Event[], count: number}> {
    if(Repository.offlineMode) {
      return {
        data: [FakeData.getEvent()],
        count: 1
      };
    }

    let path = `v1/events?latitude=${latitude}&longitude=${longitude}&kind=upcoming&published=true&sortBy=distance&page=${page}&limit=${itemsPerPage}`;
    
    if(filter) {
      path += `&filter=${filter}`;
    }

    if(latitude !== 0 && longitude !== 0) {
      path += `&maxDistance=${500000}`;
    }
    
    const response = await Repository.client.get(path);
    return {
      data: response.data.data.events.map((event: any) => Event.fromJson(event.event, currentUserId)),
      count: response.data.data.count
    };
  }

  async getEventsCreatedByUser(
    userId: string, 
    currentUserId: string, 
    page: number, 
    itemsPerPage: number
  ): Promise<{data: Event[], count: number}> {
    if(Repository.offlineMode) {
      return {
        data: [FakeData.getEvent()],
        count: 1
      };
    }

    const path = `v1/events?createdById=${userId}&kind=upcoming&page=${page}&limit=${itemsPerPage}`;
    const response = await Repository.client.get(path);
    return {
      data: response.data.data.events.map((event: any) => Event.fromJson(event.event, currentUserId)),
      count: response.data.data.count
    };
  }

  async rsvpEvent(eventId: string): Promise<void> {
    const path = `/v1/events/${eventId}/rsvps`;
    await Repository.client.post(path);
  }
}

// Create a singleton instance
export const eventsRepository = new EventsRepository();
